import { useSpring, animated } from '@react-spring/web';

const SvgLoader = () => {
    const styles = useSpring({
        from: { dashOffset: 628 }, // Circunferencia del círculo
        to: { dashOffset: 0 },
        loop: true,
        config: { duration: 2000 },
    });

    return (
        <svg width="50" height="50" viewBox="0 0 100 100">
            <animated.circle
                cx="50"
                cy="50"
                r="40"
                fill="none"
                stroke="#3498db"
                strokeWidth="10"
                strokeDasharray="628" // Circunferencia del círculo
                style={{ strokeDashoffset: styles.dashOffset }}
            />
        </svg>
    );
};

export default SvgLoader;